import { VueExtension } from '../../utils/extensions/vue';
import NoticeBar from './noticebar.jsx';
import './noticebar.scss';

VueExtension.WithInstall(NoticeBar);

export default NoticeBar;
